import styled from "styled-components";

import { Dialog } from "@libraries/mui";

import { windowWidth } from "@styles/global";

const Container = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 10px !important;
    min-width: 400px !important;

    @media (max-width: ${windowWidth.mobile.large}) {
      min-width: 95% !important;
    }
  }

  #pendencyDialog-description {
    > :not(:last-child) {
      margin-bottom: 10px;
      border-bottom: 2px solid #e0e0e0;
    }
  }
`;

const Content = styled.div`
  padding-bottom: 8px;
  display: flex;
  align-items: center;
`;

const ContentIcon = styled.div`
  margin-right: 8px;

  svg {
    fill: #ff0000;
    margin-right: 8px;
    width: 35px;
    height: 35px;
  }
`;

const ContentInfoTitle = styled.div`
  display: flex;
  font-weight: 700;
  color: #000;
`;

const ContentInfo = styled.div`
  font-weight: 500;
  font-size: 15px;
`;

const DialogActions = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;

  button {
    color: #9400ee;
  }
`;

export {
  Container,
  DialogActions,
  Content,
  ContentIcon,
  ContentInfoTitle,
  ContentInfo
};
